// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2cDl4","resendInfoText":"OnGoingPaymentBox_resendInfoText__3DQrU"};